import React from 'react';
import clsx from 'clsx';

import { Dialog, DialogContent, DialogTrigger } from './Modal';

export const CustomModal = ({
  triggerComponent,
  triggerClass = '',
  wrapperClass = 'max-lg:h-[100vh]',
  children,
  openModal,
  handleClick,
  disabled = false,
  blurred = true,
}) => {
  return (
    <Dialog
      open={openModal}
      onOpenChange={(open) => handleClick(open)}
      className={clsx('lg:max-h-[80vh] dialog-wrapper')}
    >
      <DialogTrigger
        onClick={() => handleClick(true)}
        className={triggerClass}
        disabled={disabled}
      >
        {triggerComponent}
      </DialogTrigger>
      <DialogContent blurred={blurred} className={clsx('', wrapperClass)}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default CustomModal;
